import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import { favoriteActivities } from 'store/entities/favoriteActivities/actions'
import AddToFavorites from './AddToFavorites'

const mapDispatchToProps = {
  addToFavorites: favoriteActivities.post.request,
  removeFromFavorites: favoriteActivities.delete.request,
}

export default connect(null, mapDispatchToProps)(withTranslation('user')(AddToFavorites))
